<template>
  <Layout>
    <div slot="content">
      <div class="row">
        <div class="col-xl-6">
          <!-- 왼쪽 card -->
          <TableView :title="$t('Product')" :columns="columns" @action="action" :list="leftList"
            :icon-actions="{ 'bi-pencil-fill': '수정', 'bi-trash-fill': '삭제' }" hide-pagenation :server-total="leftTotal"
            min-width="auto" minHeight="450px">
            <div class="d-flex align-items-center position-relative me-3"></div>
            <b-button variant="primary" v-b-modal.상품추가 v-text="$t('Product 추가')" @click="addBtn" />
          </TableView>
        </div>
        <div class="col-xl-6">
          <!-- 오른쪽 card -->
          <TableView :title="$t('수행업무')" slot="content" :columns="columns2" @action="taskAction" :list="rightList"
            :icon-actions="{ 'bi-pencil-fill': '수행업무수정', 'bi-trash-fill': '삭제' }" hide-pagenation :server-total="rightTotal"
            min-width="auto" minHeight="450px">
            <div class="d-flex align-items-center position-relative me-3"></div>
            <b-button variant="primary" v-b-modal.수행업무추가 v-text="$t('수행업무 추가')" @click="addBtn" />
          </TableView>
        </div>
      </div>
    </div>

    <!-- view -->
    <ModalForm id="view" :title="$t('Product')" :data="sel" :spec="columns" centered size="sm" :label-cols="4" />
    <ModalForm id="view2" :title="$t('수행업무')" :data="sel" :spec="columns2" centered ok-only size="sm" :label-cols="4" />
    <!-- 추가 -->
    <ModalForm id="상품추가" :title="$t('Product 추가')" @action="action" :ok-title="$t('추가')" :data="sel" :spec="columns"
      size="sm" :label-cols="5" centered no-close-on-ok /><!-- @action="addProductAction" -->
    <ModalForm id="수행업무추가" :title="$t('수행업무 추가')" @action="taskAction" :ok-title="$t('추가')" :data="sel" :spec="columns2"
      size="sm" centered no-close-on-ok /><!-- @action="addTaskAction" -->
    <!-- 수정 -->
    <ModalForm @action="action" id="수정" ok-title="수정" :title="$t('Product 수정')" :data="sel" :spec="editCol" size="sm"
      :label-cols="5" ref="editProduct" no-close-on-ok />
    <ModalForm @action="taskAction" id="수행업무수정" ok-title="수정" :title="$t('수행업무 수정')" :data="sel" :spec="editCol" size="sm"
      :label-cols="5" ref="editTask" no-close-on-ok />
  </Layout>
</template>
<script>
import Layout from "@/components/layout/Layout.vue";
import TableView from "@/components/TableView.vue";
import ModalForm from "@/components/ModalForm.vue";
const required = true;

export default {
  components: { Layout, TableView, ModalForm },
  data: () => ({
    sel: {},
    leftList: [],
    rightList: [],
    leftTotal: 0,
    rightTotal: 0,
    searchKeyword: '',
    listNo: 1,
    columns: [
      { key: 'prodId', form: 1, required, label: 'ID', style: { textAlign: 'center' } },
      { hide: ['수정', '수행업무수정',], key: 'prodNm', form: 2, required, label: 'Product명', style: { textAlign: 'center' } },
      { hide: ['수정', '수행업무수정',], key: 'description', form: 3, label: '설명', style: { textAlign: 'left' } },
      { hide: ['td', 'view', '상품추가'], key: 'prodNm', form: 2, required, label: '수행업무명', style: { textAlign: 'center' } },
      { hide: ['td', 'view', '상품추가'], key: 'description', form: 3, label: '설명', style: { textAlign: 'left' } },
    ],
    columns2: [
      { key: 'taskId', form: 1, required, label: 'ID', style: { textAlign: 'center' } },
      { hide: ['수정', '수행업무수정'], key: 'taskNm', form: 2, required, label: '수행업무명', style: { textAlign: 'center' } },
      { hide: ['수정', '수행업무수정'], key: 'description', form: 3, label: '설명', style: { textAlign: 'left' } },
      { hide: ['td', 'view2', '수행업무추가'], key: 'taskNm', form: 2, required, label: '수행업무명', style: { textAlign: 'center' } },
      { hide: ['td', 'view2', '수행업무추가'], key: 'description', form: 3, label: '설명', style: { textAlign: 'left' } },
    ],
    editCol: [
      { hide: ['td', 'view2', '수행업무추가', '상품추가', '수행업무수정'], key: 'prodId', form: 1, required, readonly: ['수정'], label: 'ID', style: { textAlign: 'center' } },
      { hide: ['td', 'view2', '수행업무추가', '상품추가', '수정'], key: 'taskId', form: 1, required, readonly: ['수행업무수정'], label: 'ID', style: { textAlign: 'center' } },
      { hide: ['td', 'view2', '수행업무추가', '상품추가', '수행업무수정'], key: 'prodNm', form: 2, required, label: '수행업무명', style: { textAlign: 'center' } },
      { hide: ['td', 'view2', '수행업무추가', '상품추가', '수정'], key: 'taskNm', form: 2, required, label: '수행업무명', style: { textAlign: 'center' } },
      { hide: ['td', 'view2', '수행업무추가', '상품추가'], key: 'description', form: 3, label: '설명', style: { textAlign: 'left' } },
    ],
    selected: 'loginDate',
    options: [],
  }),
  created() { this.getProdList(); this.getTaskList(); },
  mounted() {
    this.$reduceScreen();
  },
  beforeDestroy() { },
  computed: {},
  watch: { searchKeyword() { this.getProdList(); this.getTaskList(); } },
  methods: {
    async action({ action, item, form }) {
      if (!form && ['view', '수정'].includes(action)) {
        this.sel = item;
        return this.$bvModal.show(action);
      }
      if (!form && !(await this.$alert(this.$t('[$] 을(를) $ 하시겠습니까?', [item.prodNm, action]), { confirm: true, title: action }))) return;
      const res = await this.$api(`adm/set/code/${({ 수정: 'updateProd', 상품추가: 'insertProd', 삭제: 'deleteProd' })[action]}`, form || { prodId: item.prodId });
      await this.$alert(res.msg);
      if (res.success) this.$bvModal.hide(action); this.getProdList();
    },
    async taskAction({ action, item, form }) {
      if (!form && ['view', '수행업무수정'].includes(action)) {
        this.sel = item;
        return this.$bvModal.show(action == 'view' ? 'view2' : action);
      }
      if (!form && !(await this.$alert(this.$t('[$] 을(를) $ 하시겠습니까?', [item.taskNm, action]), { confirm: true, title: action }))) return;
      const res = await this.$api(`adm/set/code/${({ 수행업무수정: 'updateTask', 수행업무추가: 'insertTask', 삭제: 'deleteTask' })[action]}`, form || { taskId: item.taskId });
      await this.$alert(res.msg);
      if (res.success) this.$bvModal.hide(action); this.getTaskList();
    },
    async addBtn() { this.sel = '' },
    // async showEdit(showEd) {
    //   if (showEd == 'prod') {
    //     const { form, spec } = this.$refs.editProduct;
    //   } else { const { form, spec } = this.$refs.editTask; }
    // },
    async getProdList(firstIndex = 1) {
      this.leftList = [];
      const res = await this.$api('adm/set/code/selectProdList', { firstIndex, searchKeyword: this.searchKeyword });
      this.leftList = res.list
      if (res.parameter !== null) {
        this.leftTotal = res.parameter.total;
      }
    },
    async getTaskList(firstIndex = 1) {
      this.rightList = [];
      const res2 = await this.$api('adm/set/code/selectTaskList', { firstIndex, searchKeyword: this.searchKeyword });
      this.rightList = res2.list
      if (res2.parameter !== null) {
        this.rightTotal = res2.parameter.total;
      }
    },
  },
}
</script>

